<template>
<div>
    <div style="display: flex;">
        <HeadDetailsGama
        :titleHead="'Detalhes do Cliente'"
        :btnSolicitacoes="selectedSolicitacao.status == 2 || selectedSolicitacao.status == 3"
        @cancelarSolicitacao="$emit('cancelarSolicitacao')"
        :btnPendencyApproveRequest="selectedSolicitacao.status == 4">
        </HeadDetailsGama>
    </div>

    <div id="body-details" class="mt-4 ml-2">
                    <p  class="ml-3 subtitle">Forma de Pagamento: {{selectedSolicitacao.formaPagamento}}</p>
                    <div class="d-flex flex-wrap">
                        <div class="col-md-4">
                            <p class="label-details">Valor Total do Imóvel</p>
                            <input class="input-details" disabled v-model="selectedSolicitacao.valorTotalFormatado">
                        </div>
                        <div class="col-md-4">
                            <p class="label-details">Entrada</p>
                            <input disabled class="input-details" v-model="selectedSolicitacao.valorEntradaFormatado">
                        </div>
                        <div class="col-md-4">
                            <p class="label-details">10% na Entrega corrigido pelo Reajuste</p>
                            <input disabled class="input-details" v-model="selectedSolicitacao.valorEntregaFormatado">
                        </div>
                        <div class="col-md-4 mt-4">
                                <p class="label-details">Parcelas Balões Anuais com Reajuste Mensal</p>
                                <input disabled class="input-details" v-model="selectedSolicitacao.valorBalaoFormatado">
                        </div>
                        <div class="col-md-4 mt-4">
                                <p class="label-details">Parcelas Mensais Consecutivas com Reajuste Mensal</p>
                                <input disabled class="input-details" v-model="selectedSolicitacao.valorMensalFormatado">
                        </div>
                        <div class="col-md-4 mt-4">
                                <p class="label-details">Informação do Pagamento</p>
                                <input disabled class="input-details" v-model="selectedSolicitacao.formaPagamento">
                        </div>
                        <div class="col-md-4 mt-4">
                                <p class="label-details">Quantidade de parcelas</p>
                                <input disabled class="input-details" v-model="selectedSolicitacao.numeroParcelas">
                        </div>
                    </div>
            </div>
            <ModalRequest ref="ModalRequest"></ModalRequest>
    </div>
</template>
<script>
import PaymentConditionsDetails from './paymentConditionsDetails'
export default PaymentConditionsDetails
</script>

<style scoped>

.subtitle{
  font-size: 18px;
  color: #008148;
  margin-bottom: 15px;
}

.input-details{
  width: 100%;
  height: 35px;
  background-color: #F1F1F1;
  border: 1px solid #D4D9DE;
  border-radius: 5px;
}

.head-container{
  display: flex;
  justify-content: space-between;
}

.form-control {
  background-color: #F1F1F1 !important;
}

.label-details {
  margin: 0;
  font-size: 14px;
}

.btnApproveRequest{
  background: #008148 0% 0% no-repeat padding-box;
  border-radius: 4px;
  border: none;
  color: #fff;
  font: normal normal 600 16px/21px Segoe UI;
}

.popupRequest{
  display: grid;
  justify-content: center;
  align-items: center;
  justify-items: center;
  gap: 1rem;
}

.icone{
  font-size: 24pt;
  color:#008148;
}

.popupTitle{
  font: normal normal 600 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #2A2A2A;
}

.approve{
  background: #008148 0% 0% no-repeat padding-box;
  border-radius: 4px;
  width: 397px;
  height: 45px;
  font: normal normal 600 18px/27px Segoe UI;
  color: #FFFFFF;
  border: none;
}

.disapprove{
  background: #DB3939 0% 0% no-repeat padding-box;
  border-radius: 4px;
  width: 397px;
  height: 45px;
  font: normal normal 600 18px/27px Segoe UI;
  color: #FFFFFF;
  border: none;
}
.pendency{
  background: #CFCFCF 0% 0% no-repeat padding-box;
  border-radius: 4px;
  width: 397px;
  height: 45px;
  font: normal normal 600 18px/27px Segoe UI;
  color: #707070;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/requests/components/paymentConditionsDetails/paymentConditionsDetails.vue